// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"numbers-5"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M16 5H8V11C8 11.5523 8.44772 12 9 12H15C15.5523 12 16 12.4477 16 13V18C16 18.5523 15.5523 19 15 19H8","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Numbers5Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'numbers-5',
    ref,
    icon: element,
  },
));

Numbers5Icon.displayName = 'Numbers5Icon';

export default Numbers5Icon;
